import { render, staticRenderFns } from "./PolicyShort.vue?vue&type=template&id=9f45e788&scoped=true"
import script from "./PolicyShort.vue?vue&type=script&lang=ts"
export * from "./PolicyShort.vue?vue&type=script&lang=ts"
import style0 from "./PolicyShort.vue?vue&type=style&index=0&id=9f45e788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f45e788",
  null
  
)

export default component.exports